import React from 'react';
import type { VariantProps } from '@gluestack-ui/nativewind-utils';

import { textStyle } from './styles';

import { translateRnA11yProps, type RnAccessibilityProps } from '@/util/accessibilityProps';

type ITextProps = React.ComponentProps<'span'> &
  VariantProps<typeof textStyle> &
  RnAccessibilityProps & {
    testID?: string;
    numberOfLines?: number;
    /** Ignored on web. Single-line truncation uses CSS ellipsis with numberOfLines. */
    ellipsizeMode?: 'clip' | 'head' | 'middle' | 'tail';
  };

const Text = React.forwardRef<React.ElementRef<'span'>, ITextProps>(
  (
    {
      className,
      isTruncated,
      bold,
      underline,
      strikeThrough,
      size = 'md',
      sub,
      italic,
      highlight,
      testID,
      numberOfLines,
      ellipsizeMode: _ellipsizeMode,
      ...props
    }: { className?: string } & ITextProps,
    ref
  ) => {
    const { rest, aria } = translateRnA11yProps(props as Record<string, unknown>);

    return (
      <span
        className={textStyle({
          isTruncated: isTruncated || numberOfLines !== undefined,
          bold,
          underline,
          strikeThrough,
          size,
          sub,
          italic,
          highlight,
          class: className,
        })}
        data-testid={testID}
        {...rest}
        {...aria}
        ref={ref}
      />
    );
  }
);

Text.displayName = 'Text';

export { Text };
